module.exports = __webpack_public_path__ + "img/violet_100.7eb856bc.png";